import React from 'react';

const InvoicingView: React.FC = () => {
  return (
    <>
     <p>Invoicing View</p>
    </>
  );
};

export default InvoicingView;